import { createContext, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IdleTimerProvider } from "react-idle-timer";
import authApi from "services/apis/authApi";
import { getPathPrefix } from "utils/coreUtils";
import CacheUtils from "utils/CacheUtils";
import { types } from "features/auth/store";
const IdleTimerContext = createContext();

export const useIdleTimerContext = () => useContext(IdleTimerContext);

export const IdleTimerProviderComponent = ({ children }) => {
  const dispatch = useDispatch();
  const idleTimerRef = useRef(null);
  const isLoggedIn = useSelector((state) => state.authReducer.isLoggedIn);

  const clearLocalData = () => {
    const pathPrefix = getPathPrefix();
    localStorage.clear();
    sessionStorage.clear();
    CacheUtils.removeAllCache();
    window.location.href = pathPrefix + "login";
    dispatch({ type: types.LOGOUT_SUCCESS });
  };
  const onIdle = async () => {
    try {
      await authApi.logout();
      clearLocalData();
    } catch (error) {
      clearLocalData();
    }
  };

  return (
    <IdleTimerProvider
      ref={idleTimerRef}
      timeout={20 * 60 * 1000} // 20 minutes
      onIdle={onIdle}
      disabled={!isLoggedIn}
    >
      <IdleTimerContext.Provider value={idleTimerRef}>
        {children}
      </IdleTimerContext.Provider>
    </IdleTimerProvider>
  );
};
